export default "__VITE_ASSET__B8Eudlxn__"